import { configureStore, ThunkAction, Action, ThunkDispatch, AnyAction } from '@reduxjs/toolkit';
import counterReducer from './slices/counter/counterSlice';
import customizerReducer from './slices/customizer/customizerSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    customizer: customizerReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, undefined, AnyAction>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
